import { useState, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { GetToken } from '@utils/storage';
import * as config from '@config';

function useActivity() {
    const [data, setData] = useState(false);
    const [fetching, setFetching] = useState(false);
    const abortControllerRef = useRef(null);

    const fetchActivity = useCallback(async (id) => {
        abortControllerRef.current = new AbortController();
        setFetching(true);
        try {
            const response = await fetch(`${config.apiURL}/activity/${id}`, {
                method: 'GET',
                headers: { Authorization: `Bearer ${GetToken()}` },
                signal: abortControllerRef.current.signal,
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'An error occurred while fetch an activity');
            }
            const data = await response.json();
            // console.log('Activity fetched:', data);
            setData(data);
            return data;
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Request was aborted');
                throw new Error('Request was aborted');
            } else {
                console.error('Error fetching an activity:', error);
            }
            throw error;
        } finally {
            setFetching(false);
        }
    }, []);

    const abort = useCallback(() => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
    }, []);

    return { fetching, data, fetchActivity, abort };
}

useActivity.propTypes = {};

export default useActivity;
